.chart-overlay-wrapper
  .chart-wrapper
    div(data-hook="chart").ct-chart.products-chart
  .chart-overlay
  if (!collection.length)
    .chart-empty-overlay Leider sind noch keine Bestände vorhanden.
